import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EnumKeyValuesPipe} from './pipes/enum-to-keyvalue.pipe';
import { ValeurMonetaireFrPipe } from './pipes/valeur-monetaire.pipe';
import { ValeurNumeriqueFrPipe } from './pipes/valeur-numerique-fr.pipe';
import { ToUpperFirstLetterPipe } from './pipes/to-upper-first-letter.pipe';

@NgModule({
  declarations: [EnumKeyValuesPipe, ValeurMonetaireFrPipe, ValeurNumeriqueFrPipe, ToUpperFirstLetterPipe],
  imports: [CommonModule],
  exports: [EnumKeyValuesPipe, ValeurMonetaireFrPipe, ValeurNumeriqueFrPipe, ToUpperFirstLetterPipe]
})
export class UtilsModule {}
